module.exports = __webpack_public_path__ + "videos/animationassist-en.e3ebcf4.mp4";